import { DatePickerFieldController, Stack } from '@fukuri-admins/ui/common';
import { Button } from '@fukuri-admins/ui/common/Button';
import type { FormEventHandler } from 'react';
import { PaginatedSelectController } from '../../../../../src/component/PaginatedSelect/PaginatedSelectController';
import styles from './styles.module.scss';

type Props = {
  /** 利用企業検索アクション（ページネーション対応） */
  searchAction: React.ComponentProps<
    typeof PaginatedSelectController
  >['paginatedSelect']['searchAction'];
  /** 契約プラン検索アクション（ページネーション対応） */
  contractPlanSearchAction: React.ComponentProps<
    typeof PaginatedSelectController
  >['paginatedSelect']['searchAction'];
  /** 送信ボタンの無効化フラグ */
  isButtonDisabled: boolean;
  /** フォーム送信ハンドラ */
  onSubmit: FormEventHandler<HTMLFormElement>;
  /** キャンセルボタンクリックハンドラ */
  onCancel: React.ComponentProps<typeof Button>['onClick'];
};

/**
 * 企業契約期間 新規作成フォーム Presentation
 *
 * @param searchAction - 利用企業検索アクション（ページネーション対応）
 * @param contractPlanSearchAction - 契約プラン検索アクション（ページネーション対応）
 * @param isButtonDisabled - 送信ボタンの無効化フラグ
 * @param onSubmit - フォーム送信ハンドラ
 * @param onCancel - キャンセルボタンクリックハンドラ
 */
export const CreateClientContractTermFormPresentation: React.FC<Props> = ({
  searchAction,
  contractPlanSearchAction,
  isButtonDisabled,
  onSubmit,
  onCancel,
}) => (
  <form onSubmit={onSubmit}>
    <Stack direction='column' gap={24} width='466px'>
      <h2 className={styles.formTitle}>企業契約期間の新規作成</h2>
      <Stack direction='column' gap={16}>
        <PaginatedSelectController
          name='clientId'
          paginatedSelect={{
            searchAction,
            placeholder: '利用企業を選択してください',
            isClearable: true,
          }}
          fieldWrapperProps={{
            labelType: 'required',
            labelText: '利用企業',
          }}
        />
        <PaginatedSelectController
          name='contractPlanId'
          paginatedSelect={{
            searchAction: contractPlanSearchAction,
            placeholder: '契約プランを選択してください',
            isClearable: true,
          }}
          fieldWrapperProps={{
            labelType: 'required',
            labelText: '契約プラン',
          }}
        />
        <Stack direction='row' gap={16} alignItems='flex-start'>
          <div className={styles.dateFieldWrapper}>
            <DatePickerFieldController
              name='startedOn'
              fieldWrapperProps={{
                labelType: 'required',
                labelText: '利用開始日',
              }}
            />
          </div>
          <div className={styles.dateFieldWrapper}>
            <DatePickerFieldController
              name='endedOn'
              fieldWrapperProps={{
                labelText: '利用終了日',
              }}
            />
          </div>
        </Stack>
      </Stack>
      <Stack direction='row' gap={8}>
        <Button type='button' variant='outline' size='md' onClick={onCancel}>
          キャンセル
        </Button>
        <Button type='submit' size='md' disabled={isButtonDisabled}>
          作成
        </Button>
      </Stack>
    </Stack>
  </form>
);
